import MyModal from '@/components/my-modal';
import { groupsApis } from '@/configs/apis/groups';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import type {
  ChatGroupParams,
  ChatGroupSettingsParams,
} from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { useChatContext } from '@/contexts/chat/context';
import { UploadAvatarCrop } from '@/components/upload-avatar';
import styles from './index.module.scss';

export default function GroupHeaderEditModal({
  open,
  value,
  chat,
  onCancel,
  insertSettings,
  updateGroups,
}: {
  open: boolean;
  value: string;
  chat: Chat;
  onCancel: () => void;
  insertSettings: (params: ChatGroupSettingsParams[]) => Promise<void>;
  updateGroups: (params: ChatGroupParams[]) => Promise<void>;
}) {
  const [name, setName] = useState(value);
  const [avatar, setAvatar] = useState(chat.avatar);
  const { updateChats } = useChatContext();

  const canClickAction = useMemo(() => {
    return name.trim() !== '';
  }, [name]);

  const handleDone = async () => {
    try {
      onCancel();
      const parmas: any = {};
      const dbParmas: any = {};
      if (!avatar.startsWith('data:image/')) {
        parmas.group_head = avatar;
        dbParmas.avatar = avatar;
      }
      if (value !== name) {
        parmas.group_name = name;
        dbParmas.name = name;
      }
      await groupsApis.updateGroupInfo({
        gid: chat.chat_id,
        group_name: name,
        ...parmas,
      });
      await insertSettings([{ group_id: chat.chat_id, ...parmas }]);
      await updateGroups([{ group_id: chat.chat_id, ...dbParmas }]);
      await updateChats([{ chat_id: chat.chat_id, ...dbParmas }]);
    } catch (_) {
      // Empty
    }
  };

  useEffect(() => {
    if (!open) {
      setName(chat.name);
      setAvatar(chat.avatar);
    }
  }, [chat.avatar, chat.name, open]);

  return (
    <MyModal
      title="Edit Group"
      open={open}
      cancelText="Cancel"
      onCancel={onCancel}
      canClickAction={canClickAction}
      actionText="Save"
      onAction={handleDone}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.avatar}>
            <UploadAvatarCrop
              avatar={avatar || chat.avatar}
              uploadProps={{
                onChange: setAvatar,
              }}
            ></UploadAvatarCrop>
          </div>
          <div className={styles.avatarText}>Add Photo</div>
        </div>
        <Input value={name} onChange={(e) => setName(e.target.value)} />
      </div>
    </MyModal>
  );
}
